import { Alert, Button } from "@mui/material"
import { navigate } from "lib/routes/navigate"

/**
 * Shown in the Optimiser UI once a background promotion has produced a draft regime, offering
 * a one-click jump to it. Dismissible.
 *
 * @param {{ regimeId: string, onDismiss: () => void }} props
 */
export function PromotedRegimeBanner({ regimeId, onDismiss }) {
    return (
        <Alert
            severity="success"
            onClose={onDismiss}
            data-cy="promoted-regime-banner"
            action={
                <Button color="inherit" size="small" onClick={openRegime} data-cy="promoted-regime-open">
                    Open draft regime
                </Button>
            }
            sx={{ mb: 2 }}
        >
            Your draft regime is ready.
        </Alert>
    )

    function openRegime() {
        navigate(`/app/schedules?id=${regimeId}`)
    }
}
